import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/*Add Email Type Service*/ 
const addEmailType = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.createEmailType}`,
    method: "POST",
    data: params,
    withCredentials:config?.withCredentials,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Get Email Type Service*/
const getEmailType = (params)=>{
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getEmailType}`,
      method: "GET",
      // params: params,
      withCredentials:config?.withCredentials,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;

}

/*Add Email Template Service*/
const addEmailTemplate = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.createEmailTemplate}`,
      method: "POST",
      data: params,
      withCredentials:config?.withCredentials,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error?.response?.data);
      });
    return response;
  };

  /*Get Email Template Service*/
  const getEmailTemplate = (params)=>{
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getEmailTemplate}`,
      method: "GET",
      // params: params,
      withCredentials:config?.withCredentials,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;

}
/*Update Email Template Service*/
const updateEmailTemplate = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.updateEmailTemplate}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};


/*Delete Email Template Service*/
 const deleteEmailTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.deleteEmailtemplate}`,
    method: "DELETE",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Remove Image Template Service*/
const removeImageTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.removeImageTemplate}`,
    method: "DELETE",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};


/* Add Action Email Template Service*/
const AddActionEmailTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.addActionTemplate}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Get Action Email Template Service*/
const getActionEmailTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getActionTemplate}`,
    method: "GET",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Update Action Email Template Service*/
const UpdateActionEmailTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.UpdateAction}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Delete Action Email Template Service*/
const DeletActionEmailTemplate = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.deleteAction}`,
    method: "DELETE",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Get Action Type Service*/
const getActionType = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getActionType}`,
    method: "GET",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};


export default {
    addEmailType,
    getEmailType,
    addEmailTemplate,
    getEmailTemplate,
    updateEmailTemplate,
    deleteEmailTemplate,
    removeImageTemplate,
    AddActionEmailTemplate,
    getActionEmailTemplate,
    getActionType,
    UpdateActionEmailTemplate,
    DeletActionEmailTemplate
}